// DC Mem SR
export class DCMemSR {
    "DC Channel": string = "Online";
    "SR Sub Type": string = "";
    "DC Member Name(Arabic)": string = "";
    "DC Member Name(English)": string = "";
    "SR Type": string = "";
    "DC Cancel Reason": string = "";
    "DC Cancel Letter Req": string = "Yes"; // Yes/No
    "DC IBAN Num": string = "";
    "Bank Name": string = "";
    "DC Account Holder": string = "";
    "Reason": string = "";
    // Optional fields
    "SR Number"?: string;
    "Account Id"?: string;
    "Status"?: string;
}

// ListOfDCMemSRIO
export class ListOfDCMemSRIO {
    "DC Mem SR": DCMemSR = new DCMemSR();
}

// Siebel Message
export class SiebelMessage {
    xmlns: string = "http://www.siebel.com/xml/DC%20Query%20Member%20Info";
    MessageId: string = ""; // should be generated dynamically
    MessageType: string = "Integration Object";
    IntObjectName: string = "DCMemSRIO";
    IntObjectFormat: string = "Siebel Hierarchical";
    ListOfDCMemSRIO: ListOfDCMemSRIO = new ListOfDCMemSRIO();
}
// Request Body
export class MembershipCancellationBody {
    ProcessName: string = "DC Create Update SR Web WF";
    DCMethod: string = 'SAVEASDRAFT';
    SiebelMessage: SiebelMessage = new SiebelMessage();
}
// Final Payload
export class MembershipCancellationRequest {
    body: MembershipCancellationBody = new MembershipCancellationBody();
}
